import { useRef, useEffect } from "react";
import { message } from "antd";
import clsx from "clsx";
import { Outlet, useLocation } from "react-router-dom";
import { ExternalLinkHandler } from "@shared/ui";
import { PrivateCheck } from "../../user/ui/private/private-check";
import "./unified-layout.scss";

export const UnifiedLayout = () => {
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isInIframe = window.parent !== window;

  const [, contextHolder] = message.useMessage();

  useEffect(() => {
    const isLegacyUrl = location.pathname.includes('/u/projects/l');

    if (isInIframe && !isLegacyUrl) {
      try {
        window.parent.postMessage(
          {
            type: 'navigation',
            path: location.pathname,
          },
          '*',
        );
      } catch (error) {
        // Silent error
      }
    }
  }, [location.pathname, isInIframe]);

  return (
    <PrivateCheck>
      <ExternalLinkHandler>
        <div
          ref={containerRef}
          className={clsx("unified-layout", isInIframe && "unified-layout--iframe")}
          data-unified-mode="true"
        >
          {contextHolder}
          <main ref={ref} className="unified-layout__main">
            <Outlet
              context={{
                wrapperRef: ref,
              }}
            />
          </main>
        </div>
      </ExternalLinkHandler>
    </PrivateCheck>
  );
};
